import React from "react";
import './loginAccount.css';
import { useForm } from 'react-hook-form';
import validationRules from '../../util/validationRules/ValidationRules';
import Header from "../layout/Header";
import Footer from "../layout/Footer";

const LoginAccount = () => {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();

    const onSubmit = (data) => {
        console.log(data);
    };

    return (
        <React.Fragment>
            <Header />
            <div className="create_account_form_main">
                <div className="container">
                    <div className="form_area">
                        <h4 className="create_form_heading">Log In To Your Account</h4>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="row">
                                <div className="col-12">
                                    <div className="mb-3">
                                        <label htmlFor="idUserID" className="form-label">Email ID</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="idUserID"
                                            aria-describedby="idUserID"
                                            placeholder="Enter Email ID"
                                            name="idUserID"
                                            {...register('idUserID', {
                                                required: { value: validationRules.userName.required, message: validationRules.userName.requiredMsg },
                                                pattern: {
                                                    value: validationRules.userName.pattern,
                                                    message: validationRules.userName.message,
                                                },
                                            })}
                                        />
                                        {errors.idUserID && (
                                            <p className="error-message text-danger">{errors.idUserID.message}</p>
                                        )}
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="mb-3">
                                        <label htmlFor="idPassword" className="form-label">Enter Password</label>
                                        <input
                                            type="password"
                                            className="form-control"
                                            id="idPassword"
                                            aria-describedby="idPassword"
                                            placeholder="Enter Password"
                                            name="idPassword"
                                            {...register('idPassword', {
                                                required: { value: validationRules.password.required, message: validationRules.password.requiredMsg },
                                                pattern: {
                                                    value: validationRules.password.pattern,
                                                    message: validationRules.password.message,
                                                },
                                            })}
                                        />
                                        {errors.idPassword && (
                                            <p className="error-message text-danger">{errors.idPassword.message}</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="create_account_btn_area">
                                <button type="submit" className="create_account_btn">Log In</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <Footer />
        </React.Fragment>
    )
}

export default LoginAccount;